const MINUTE_MS = 60_000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const DAYS_PER_MONTH = 30;
const DAYS_PER_YEAR = 365;

// "now", "5m", "3h", "12d", "2mo", "1y" since `iso`; no "ago", the column header gives that.
export function formatCompactDuration(iso: string | null, now: number): string {
    if (!iso) return '-';
    const time = new Date(iso).getTime();
    if (Number.isNaN(time)) return '-';

    const minutes = Math.floor((now - time) / MINUTE_MS);
    if (minutes < 1) return 'now';
    if (minutes < MINUTES_PER_HOUR) return `${minutes}m`;

    const hours = Math.floor(minutes / MINUTES_PER_HOUR);
    if (hours < HOURS_PER_DAY) return `${hours}h`;

    const days = Math.floor(hours / HOURS_PER_DAY);
    if (days < DAYS_PER_MONTH) return `${days}d`;
    // Months and years gate on the same day count, so days 360-364 read "12mo", never "0y".
    if (days < DAYS_PER_YEAR) return `${Math.floor(days / DAYS_PER_MONTH)}mo`;
    return `${Math.floor(days / DAYS_PER_YEAR)}y`;
}
